module.exports = __webpack_public_path__ + "assets/25d62f901854020e07a43e2a9d547c46.mp3";